import { Filter } from "iconoir-react";
import MainLayout from "../layouts/MainLayout";
import { memo, useState } from "react";
import Message from "../components/common/Message";
import { inject, observer } from "mobx-react";
import { useTheme } from "@mui/material";
import { ListUserContact } from "../modules/contact";
import DocumentPage from "./DocumentPage";
import ContactPage from "./ContactPage";

const ListUserContactPage = () => {
  const [openMessage, setOpenMessage] = useState(false);

  const theme = useTheme();
  return (
    <div style={{ background: theme.background.base, minHeight: "850px" }}>
      <div
        className="flex justify-between items-center py-[20px] pl-[60px] pr-[20px] fixed w-full z-50"
        style={{
          background: theme.background.header,
          color: theme.color.text1,
        }}
      >
        <div className="font-bold text-[28px] leading-[29px]  ">Danh bạ</div>
        {/* <span
          className="w-5 cursor-pointer"
          onClick={() => {
            setOpenMessage(true)
          }}>
          <Filter />
        </span> */}
      </div>
      <MainLayout>
        <div className="px-2 pt-20">
          <ContactPage valueInit={0} />
          <ListUserContact />
        </div>
        <Message
          message="Tính năng đang phát triển"
          openMessage={openMessage}
          severity="warning"
          closeMessage={() => {
            setOpenMessage(false);
          }}
        />
      </MainLayout>
    </div>
  );
};

export default memo(inject("aclStore")(observer(ListUserContactPage)));
